import { Link, useLocation } from 'react-router-dom';
import { tenantBasePath } from '../../lib/tenant.js';
import { yarPlacementForPath } from './yarConfig.ts';
import './yar.css';

/**
 * Bottom-left floating assistant. Shows only the character of the module the
 * user is in (the general «ساختار یار» outside modules) and opens that
 * assistant's page. Whether the assistant answers is decided on that page.
 */
export function YarFab({ slug }: { readonly slug: string }) {
  const { pathname } = useLocation();
  const placement = yarPlacementForPath(pathname, tenantBasePath(slug));
  if (!placement) return null;
  const { yar, href } = placement;
  return (
    <Link
      to={href}
      className="yar-fab"
      data-yar={yar.key}
      aria-label={`${yar.name} — دستیار ${yar.moduleLabel}`}
      style={{ ['--yar-main' as string]: yar.main, ['--yar-light' as string]: yar.light }}
    >
      <img src={yar.image} alt="" width={64} height={64} draggable={false} />
      <span className="yar-fab__label">{yar.name}</span>
    </Link>
  );
}
